import { PERIOD } from '../../constants/shared/CommonConstants';
import { MEASURE } from '../../constants/shared/MeasuresConstants';
import { GRADE } from '../../constants/shared/GradesConstants';

const { PM } = PERIOD;
const { LNF, PSF, FNL } = MEASURE;
const { SECOND_GRADE } = GRADE;

const OPTIONAL_MEASURES = [LNF, PSF, FNL];

export const isAdditionalMeasure = (measureKey, grade, period = '') =>
    grade === SECOND_GRADE &&
    (([LNF, PSF].includes(measureKey) && period !== PM) || measureKey === FNL);

export const filterOutAdditionalMeasures = (measures = [], noPeriodFilter = false) =>
    measures.filter(
        ({ measure, grade, period }) =>
            !isAdditionalMeasure(measure, grade, noPeriodFilter || period),
    );

export const filterResultsOfAdditionalMeasures = studentsResults =>
    Object.entries(studentsResults).reduce((acc, [key, result]) => {
        const { results, statuses } = result;
        return {
            ...acc,
            [key]: {
                ...result,
                results: filterOutAdditionalMeasures(results),
                statuses: filterOutAdditionalMeasures(statuses),
            },
        };
    }, {});

export const filterAdditionalMeasuresFromMapper = mapper => {
    return mapper?.map(item =>
        item.key === SECOND_GRADE
            ? {
                  ...item,
                  measures: item.measures.filter(measure => !OPTIONAL_MEASURES.includes(measure)),
              }
            : item,
    );
};
